<template>
    <div class="TargetEditorPane">
        <div class="row">
            <div class="col">
                <h2>Edit Program Targets</h2>
                <p>Today's Targets are in <span class="lightblueback">BLUE</span></p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Metric Name:</label>
                    <select v-model="Filters.MetricName" class="form-control">
                        <option value="ALL">ALL</option>
                        <option v-for="option in FilterSelectOptions.MetricNames" :value="option">{{ option }}</option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Core Program:</label>
                    <select v-model="Filters.CoreProgram" class="form-control">
                        <option value="ALL">ALL</option>
                        <option v-for="option in FilterSelectOptions.CorePrograms" :value="option">{{ option }}</option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Region:</label>
                    <select v-model="Filters.Region" class="form-control">
                        <option value="ALL">ALL</option>
                        <option v-for="option in FilterSelectOptions.Regions" :value="option">{{ option }}</option>
                    </select>
                </div>
            </div>
            <div class="col">

            </div>
        </div>
        <div class="row">
            <div class="col">
                <div v-for="currentTarget in FilteredTargets">
                    <TargetEditor :description="currentTarget.Description"
                                  :target-name="currentTarget.Name"
                                  :primary-specifier="currentTarget.PrimarySpecifier"
                                  :secondary-specifier="currentTarget.SecondarySpecifier"
                                  :core-program-specifier="currentTarget.CoreProgramSpecifier"
                                  :employee-specifier="currentTarget.EmployeeSpecifier"
                                  :sub-program-specifier="currentTarget.SubProgramSpecifier"
                                  :region-specifier="currentTarget.RegionSpecifier" />
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    //import components
    import TargetEditor from './TargetEditor.vue';

    export default {
        name: "TargetEditorPane",
        props: [
            "SecondarySpecifier"
        ],
        data: function () {
            return {
                CurrentTargets: [],
                Filters: {
                    MetricName: "",
                    CoreProgram: "ALL",
                    Region: "ALL"
                }
            };
        },
        methods: {
            GetData() {
                this.$MasterAPI.ExecuteRequest("GET", "Dashboards/ExpectedTargets/CurrentTargetsBySecondarySpecifier", { SecondarySpecifier: this.SecondarySpecifier }, this.GetDataSuccess, () => { }, true);
            },
            GetDataSuccess(response) {
                this.CurrentTargets = response.data.data;
            },
        },
        components: {
            TargetEditor
        },
        mounted() {
            this.GetData();
        },
        computed: {
            FilterSelectOptions: function () {
                let output = {
                    MetricNames: [],
                    CorePrograms: [],
                    Regions: []
                };
                this.CurrentTargets.forEach(function (target) {
                    let desc = target.Description;
                    let colonLocation = desc.indexOf(":");
                    let dashLocation = desc.indexOf("-");
                    let metricName = desc.substring(0, colonLocation);
                    let coreProgram = desc.substring(colonLocation + 2, dashLocation - 1);
                    let region = desc.substring(dashLocation + 2);


                    if (output.MetricNames.includes(metricName) == false) {
                        output.MetricNames.push(metricName);
                    }
                    if (output.CorePrograms.includes(coreProgram) == false) {
                        output.CorePrograms.push(coreProgram);
                    }
                    if (output.Regions.includes(region) == false) {
                        output.Regions.push(region);
                    }
                });

                return output;
            },
            FilteredTargets: function () {
                let vm = this;
                let output = [];
                this.CurrentTargets.forEach(function (target) {
                    let desc = target.Description;
                    let colonLocation = desc.indexOf(":");
                    let dashLocation = desc.indexOf("-");
                    let metricName = desc.substring(0, colonLocation);
                    let coreProgram = desc.substring(colonLocation + 2, dashLocation - 1);
                    let region = desc.substring(dashLocation + 2);

                    if (vm.Filters.MetricName == "ALL" || metricName == vm.Filters.MetricName) {
                        if (vm.Filters.CoreProgram == "ALL" || coreProgram == vm.Filters.CoreProgram) {
                            if (vm.Filters.Region == "ALL" || region == vm.Filters.Region) {
                                output.push(target);
                            }
                        }
                    }

                    
                    
                });

                return output;
            }
        }
    }
</script>

<style scoped>

</style>